import { useRouter } from '@uirouter/react';
import { useImmerAtom } from 'jotai-immer';
import { ROUTE_LIST } from '../../groups_const';
import { pageStateGroupsCreateAtom } from '../groups_create_atoms';
import { PageStoreHook, GroupsCreatePageState, PageMode } from '../groups_create_types';
import { useCallback } from 'react';

export const useGroupsCreateStore = (): PageStoreHook<GroupsCreatePageState> => {
    const router = useRouter();
    const [state, setState] = useImmerAtom(pageStateGroupsCreateAtom);

    const setEditStatus = useCallback(
        (canEdit: boolean) => {
            setState(draft => ({ ...draft, canEdit }));
        },
        [setState],
    );

    const setPageMode = useCallback(
        (mode: PageMode, id: string): void => {
            setState(draft => ({
                ...draft,
                mode,
                title: mode === 'CREATE' ? 'Create Group' : 'Update Group',
                init: false,
                id,
            }));
        },
        [setState],
    );

    const cancelEdit = useCallback((): void => {
        router.stateService.go(ROUTE_LIST);
    }, [router.stateService]);

    return {
        state,
        setEditStatus,
        setPageMode,
        cancelEdit,
    };
};
